import React, { useState, useEffect } from "react";
import "../../../App.css";
import PageTitle from "../../../Module/pageTitle";
import { useDispatch } from "react-redux";
import SubmitButton from "../../../Component/SubmitButton";
import CustomDropdown from "../../../Component/customDropdown";
import LabelField from "../../../Component/labelField";
import CustomDropdownExamname from "../../../Component/customDropdownExamname";
import {
    getExamSet,
    getExamQuestion,
    copyExamset,
    getBatchList,
    getPatternByExamType,
    getParentCourseNew,
    getExamListNew,
    getExamQuestionSubjects,
    getExamQuestionTopics,
    getExamQuestionYear,
    getExamQuestionNew,
} from "../../../Action/courseAction";
import { data, examTypesList } from "../../../Utils/dataConstants";
import ToggleSwitchBtn from "../../../Component/toggleSwitchBtn";
import { renderQuestions } from "../../../Utils/utils";
import { getSubExam } from "../../../Action/adminPanelAction";
import DateTime from "../../../Component/dateTime";
import InputField from "../../../Component/inputField";
import { length_One, length_Three } from "../../../Utils/validators";
import { addQuizOfTheDay, getQuizChannelList } from "../../../Action/actionFile";
import Dropdown from "../../../Component/dropdown";
const initialResetVal = {
    parentCourse: false,
    exam: false,
    subExam: false,
    pattern: false,
    examType: false,
    examSet: false,
    batch: false,
    subject: false,
    topic: false,
    year: false,
};

const CopyQuestionToQuiz = () => {
    const dispatch = useDispatch();
    const [parentCourse, setParentCourse] = useState("");
    const [examName, setExamName] = useState("");
    const [subExamName, setSubExamName] = useState("");
    const [examType, setExamType] = useState("");
    const [isFreeUser, setIsFreeUser] = useState(false);
    const [batchName, setBatchName] = useState("");
    const [modelSet, setModelSet] = useState(false);
    const [patternName, setPatternName] = useState("");
    const [examSet, setExamSet] = useState("");

    const [parentCourseList, setParentCourseList] = useState([]);
    const [examList, setExamList] = useState([]);
    const [subExamList, setSubExamList] = useState([]);
    const [examTypeList, setExamTypeList] = useState([]);
    const [batchList, setBatchList] = useState([]);
    const [patternList, setPatternList] = useState([]);
    const [examSetList, setExamSetList] = useState([]);
    const [resetState, setResetState] = useState(initialResetVal);
    const [examSetArray, setExamSetArray] = useState([]);

    const [selectedSectionId, setSelectedSectionId] = useState(0);

    const [questionsListCopy, setQuestionsListCopy] = useState([]);
    const [subject, setSubject] = useState("");
    const [subjectList, setSubjectList] = useState([]);
    const [topic, setTopic] = useState("");
    const [topicList, setTopicList] = useState([]);
    const [year, setYear] = useState("");
    const [yearList, setYearList] = useState([]);
    const [checkall, setcheckall] = useState(false);

    const [isPYQ, setIsPYQ] = useState(false);
    const [isPracticeTest, setIsPracticeTest] = useState(false);

    const [parentCourseCopy, setParentCourseCopy] = useState("");
    const [examNameCopy, setExamNameCopy] = useState("");
    const [topicName, setTopicName] = useState("");
    const [parentCourseListCopy, setParentCourseListCopy] = useState([]);
    const [resetParentCourse, setResetParentCourse] = useState(false);
    const [resetExam, setResetExam] = useState(false);
    const [chatID, setChatID] = useState("");
    const [resetChatID, setResetChatID] = useState(false);
    const [ChatList, setChatList] = useState([]);
    const [quizStartDate, setQuizStartDate] = useState("");
    const [duration, setDuration] = useState("");

    useEffect(() => {
        dispatch(
            getExamListNew((res) => {
                setExamList(res);
            })
        );
        dispatch(
            getQuizChannelList((res) => {
                setChatList(res);
            })
        );
    }, []);

    const onListChange = (value) => {
        setExamName(value);
        setSubExamName("");
        setSubExamList([]);
        setParentCourseList([]);
        setPatternList([]);
        setPatternName("");
        setExamSet("");
        setExamTypeList([]);
        setBatchName("");
        setResetState((prevState) => ({
            ...prevState,
            exam: false,
            subExam: true,
            examType: true,
            batch: true,
            pattern: true,
            examSet: true,
            subject: true,
            topic: true,
            year: true,
        }));
        dispatch(
            getSubExam(
                {
                    examTypeId: value._id,
                },
                (res) => {
                    if (res.data.length !== 0) {
                        setSubExamList(res.data);
                    } else {
                        setExamTypeList(examTypesList);
                        dispatch(
                            getParentCourseNew(`${value._id}`, (res) => {
                                setParentCourseList(res);
                            })
                        );
                    }
                }
            )
        );
    };

    const onSubExamChange = (value) => {
        setSubExamName(value);
        setResetState((prevState) => ({
            ...prevState,
            exam: false,
            subExam: false,
            examType: true,
            batch: true,
            pattern: true,
            examSet: true,
            subject: true,
            topic: true,
            year: true,
        }));
        setExamTypeList(examTypesList);
        dispatch(
            getParentCourseNew(`${examName._id}/${value._id}`, (res) => {
                setParentCourseList(res);
            })
        );
    };

    const onChangeParentCourse = (value) => {
        setParentCourse(value);
        setExamSetList([]);
        setExamSet("");
        setPatternList([]);
        setPatternName("");
        setBatchName("");
        setResetState((prevState) => ({
            ...prevState,
            examType: true,
            batch: true,
            pattern: true,
            examSet: true,
            subject: true,
            topic: true,
            year: true,
        }));
    };

    const onExamTypeChange = (value) => {
        setExamType(value);
        setExamSet("");
        setIsFreeUser(false);
        setExamSetList([]);
        setPatternList([]);
        setBatchList([]);
        setBatchName("");
        setResetState((prevState) => ({
            ...prevState,
            exam: false,
            subExam: false,
            examType: false,
            batch: true,
            pattern: true,
            examSet: true,
            subject: true,
            topic: true,
            year: true,
        }));

        const postData = {
            baseCourseId: parentCourse._id,
            examTypeId: examName._id,
            examType: value._id,
        };

        if (subExamName) {
            postData["subExamTypeId"] = subExamName?._id;
        }

        if (
            !isFreeUser &&
            (value?._id === 1 ||
                value?._id === 2 ||
                value?._id === 4 ||
                value?._id === 6)
        ) {
            dispatch(
                getBatchList(
                    postData,
                    (res) => {
                        setBatchList(res.data);
                    },
                    () => { }
                )
            );
        }
        if (value?._id === 3 || value?._id === 7) {
            dispatch(
                getPatternByExamType(
                    postData,
                    (res) => {
                        setPatternList(res.data);
                    },
                    () => { }
                )
            );
        }
    };

    const toggleChange = (event) => {
        if (event.target.checked) {
            setIsFreeUser(true);
            setExamTypeList(examTypesList);
            setBatchList([]);
            setBatchName("");

            const postData = {
                baseCourseId: parentCourse._id,
                examTypeId: examName._id,
                examType: examType._id,
            };

            if (subExamName) {
                postData["subExamTypeId"] = subExamName?._id;
            }

            dispatch(
                getPatternByExamType(
                    postData,
                    (res) => {
                        setPatternList(res.data);
                    },
                    () => { }
                )
            );
        } else {
            setIsFreeUser(false);
            setExamTypeList(examTypesList);
            if (parentCourse && examName && examType) {
                const postData = {
                    baseCourseId: parentCourse._id,
                    examTypeId: examName._id,
                    examType: examType._id,
                };

                if (subExamName) {
                    postData["subExamTypeId"] = subExamName?._id;
                }
                dispatch(
                    getBatchList(
                        postData,
                        (res) => {
                            setBatchList(res.data);
                        },
                        () => { }
                    )
                );
            }
        }
    };

    const onBatchChange = (value) => {
        setBatchName(value);
        setResetState((prevState) => ({
            ...prevState,
            exam: false,
            subExam: false,
            examType: false,
            batch: false,
            pattern: true,
            examSet: true,
            subject: true,
            topic: true,
            year: true,
        }));
        const postData = {
            baseCourseId: parentCourse._id,
            examTypeId: examName._id,
            subExamTypeId: subExamName._id,
            examType: examType._id,
            courseId: value._id,
        };

        if (subExamName?._id) {
            postData["subExamTypeId"] = subExamName?._id;
        }

        dispatch(
            getPatternByExamType(
                postData,
                (res) => {
                    setPatternList(res.data);
                },
                () => { }
            )
        );
    };

    const onChangeModelSet = (value) => {
        setModelSet(value);
        let data = {
            baseCourseId: parentCourse?._id,
            examTypeId: examName?._id,
            examType: examType._id,
            isSectionWise: value?._id,
        };
        if (subExamName) {
            data["subExamTypeId"] = subExamName?._id;
        }
        dispatch(
            getPatternByExamType(
                data,
                (res) => {
                    setPatternList(res.data);
                },
                () => { }
            )
        );
    };

    const onChangePattern = (value) => {
        setPatternName(value._id);
        setExamSetArray([]);
        setResetState((prevState) => ({
            ...prevState,
            exam: false,
            subExam: false,
            examType: false,
            batch: false,
            pattern: false,
            examSet: true,
            subject: true,
            topic: true,
            year: true,
        }));
        const postData = {
            baseCourseId: parentCourse._id,
            examTypeId: examName._id,
            examType: examType._id,
            examPatternId: value._id,
        };

        if (subExamName) {
            postData["subExamTypeId"] = subExamName?._id;
        }
        if (batchName) {
            postData["courseId"] = batchName?._id;
        }
        if (
            examType?._id === 1 ||
            examType?._id === 2 ||
            examType?._id === 4 ||
            examType?._id === 3
        ) {
            postData.isFreeUser = isFreeUser;
        }
        if (examType?._id === 1 || examType?._id === 3) {
            postData.isPYQ = isPYQ;
        }
        if (examType?._id === 1 || examType?._id === 2 || examType?._id === 3) {
            postData.isPracticeTest = isPracticeTest;
        }
        dispatch(
            getExamSet(
                postData,
                (res) => {
                    setExamSetList(res?.data?.exams);
                },
                () => { }
            )
        );
    };

    const onExamSetChange = (value) => {
        setExamSetArray([]);
        setExamSet(value);
        setResetState((prevState) => ({
            ...prevState,
            exam: false,
            subExam: false,
            examType: false,
            batch: false,
            pattern: false,
            examSet: false,
            subject: true,
            topic: true,
            year: true,
        }));
        dispatch(
            getExamQuestionNew(
                value._id,
                {},
                (res) => {
                    const data = res?.data;
                    var arr = [];
                    data?.sections?.map((item) => {
                        return arr.push({
                            sections: item,
                            questions: getSectionWiseQuestion(item?._id, data?.questions),
                        });
                    });
                    setSelectedSectionId(arr[0].sections?._id);
                    setExamSetArray(arr);
                },
                () => { }
            )
        );
        dispatch(
            getExamQuestionSubjects(
                value?._id,
                (res) => {
                    setSubjectList(res);
                },
                () => { }
            )
        );
    };

    const onSubjectChange = (value) => {
        setSubject(value);
        setResetState((prevState) => ({
            ...prevState,
            exam: false,
            subExam: false,
            examType: false,
            batch: false,
            pattern: false,
            examSet: false,
            subject: false,
            topic: true,
            year: true,
        }));
        dispatch(
            getExamQuestionNew(
                examSet._id,
                {
                    subjectId: value?._id,
                },
                (res) => {
                    const data = res?.data;
                    var arr = [];
                    data?.sections?.map((item) => {
                        return arr.push({
                            sections: item,
                            questions: getSectionWiseQuestion(item?._id, data?.questions),
                        });
                    });
                    setSelectedSectionId(arr[0].sections?._id);
                    setExamSetArray(arr);
                },
                () => { }
            )
        );
        dispatch(
            getExamQuestionTopics(
                {
                    examId: examSet?._id,
                    subjectId: value?._id,
                },
                (res) => {
                    setTopicList(res.data);
                },
                () => { }
            )
        );
    };

    const onTopicChange = (value) => {
        setTopic(value);
        setResetState((prevState) => ({
            ...prevState,
            exam: false,
            subExam: false,
            examType: false,
            batch: false,
            pattern: false,
            examSet: false,
            subject: false,
            topic: false,
            year: true,
        }));

        dispatch(
            getExamQuestionNew(
                examSet._id,
                {
                    subjectId: subject._id,
                    topicId: value?._id,
                },
                (res) => {
                    const data = res?.data;
                    var arr = [];
                    data?.sections?.map((item) => {
                        return arr.push({
                            sections: item,
                            questions: getSectionWiseQuestion(item?._id, data?.questions),
                        });
                    });
                    setSelectedSectionId(arr[0].sections?._id);
                    setExamSetArray(arr);
                },
                () => { }
            )
        );
        dispatch(
            getExamQuestionYear(
                {
                    examId: examSet._id,
                    subjectId: subject._id,
                    topicId: value?._id,
                },
                (res) => {
                    setYearList(res.data);
                },
                () => { }
            )
        );
    };

    const onYearChange = (value) => {
        setYear(value);
        setResetState((prevState) => ({
            ...prevState,
            exam: false,
            subExam: false,
            examType: false,
            batch: false,
            pattern: false,
            examSet: false,
            subject: false,
            topic: false,
            year: false,
        }));

        dispatch(
            getExamQuestionNew(
                examSet._id,
                {
                    subjectId: subject._id,
                    topicId: topic?._id,
                    examYear: value?._id,
                },
                (res) => {
                    const data = res?.data;
                    var arr = [];
                    data?.sections?.map((item) => {
                        return arr.push({
                            sections: item,
                            questions: getSectionWiseQuestion(item?._id, data?.questions),
                        });
                    });
                    setSelectedSectionId(arr[0].sections?._id);
                    setExamSetArray(arr);
                },
                () => { }
            )
        );
    };

    const onListChangeCopy = (value) => {
        setExamName(value);
        setResetExam(false);
        setParentCourseListCopy([]);
        setResetParentCourse(true);
        dispatch(
            getParentCourseNew(`${value._id}`, (res) => {
                setParentCourseListCopy(res);
            })
        );
    };

    const onChangeParentCourseCopy = (value) => {
        setParentCourseCopy(value);
        setResetParentCourse(false);
    };

    const changeChatId = (value) => {
        setChatID(value);
        setResetChatID(false);
    }

    const checkval = (event) => {
        let newArray = JSON.parse(JSON.stringify(examSetArray));
        newArray.map((item) => {
            return item.questions.map((ques) => {
                if (ques._id === event.target.id)
                    Object.assign(ques, { isSelected: event.target.checked });
                return item;
            });
        });
        setExamSetArray(newArray);
        let totalQues = 0;
        newArray.map((item) => {
            return (totalQues = totalQues + item?.questions?.length);
        });

        const arr = [];
        newArray?.map((item) =>
            item?.questions?.filter((data) => {
                if (getQuestionsId(data)) arr.push(getQuestionsId(data));
            })
        );

        if (totalQues === arr?.length) {
            setcheckall(true);
        } else {
            setcheckall(false);
        }
    };

    const getQuestionsId = (data) => {
        if (data.isSelected === true) return {
            title: data?.en?.title || [],
            options: data?.en?.options || [],
            ansDescription: data?.en?.ansDescription || [],
            questionType: data?.questionType,
            _id: data._id,
        };
        else return;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const arr = [];
        console.log("examSetArray", examSetArray);
        examSetArray?.map((item) =>
            item?.questions?.filter((data) => {
                if (getQuestionsId(data)) arr.push(getQuestionsId(data));
            })
        );
        console.log("selected questions id", arr);
        const updated = arr?.map(q => {
            const { _id, ...restQuestion } = q;
            const { image, ...ansRest } = q.ansDescription || {};

            return {
                ...restQuestion,
                title: q.title.map(({ _id, ...rest }) => rest),
                options: q.options.map(({ _id, ...rest }) => rest),
                ansDescription: {
                    ...ansRest,
                    img: image || ""
                }
            };
        });

        const payload = {
            examTypeId: examName?._id,
            baseCourseId: parentCourseCopy?._id,
            channelId: chatID?._id,
            startDate: quizStartDate,
            duration: duration,
            topicName: topicName,
            questions: updated,
        };
        console.log("payload", payload);
        dispatch(
            addQuizOfTheDay(payload, () => {
                setExamName("");
                setResetExam(true);
                setChatID("");
                setResetChatID(true);
                setTopicName("");
                setParentCourseCopy("");
                setDuration("");
                setResetParentCourse(true);
                setQuizStartDate("");
                setExamSetArray([]);
                setcheckall(false);
                
                // setQuestionData([
                //     {
                //         title: [],
                //         options: [],
                //         ansDescription: { text: "", img: "", video: "" },
                //         questionType: 1,
                //     },
                // ]);
            })
        );

    };

    const handleSectionAllQuestions = (event, index) => {
        let newArray = JSON.parse(JSON.stringify(examSetArray));

        newArray[index].sections.isSectionChecked = event.target.checked;
        for (let i = 0; i < newArray[index]["questions"].length; i++) {
            newArray[index]["questions"][i].isSelected = event.target.checked;
        }
        setExamSetArray(newArray);
        let selectedQues = newArray?.filter((item) => {
            if (item?.sections?.isSectionChecked) {
                return item;
            }
        });
        let totalQues = 0;
        newArray.map((item) => {
            return (totalQues = totalQues + item?.questions?.length);
        });

        const arr = [];
        selectedQues?.map((item) =>
            item?.questions?.filter((data) => {
                if (getQuestionsId(data)) arr.push(getQuestionsId(data));
            })
        );

        if (totalQues === arr?.length) {
            setcheckall(true);
        } else {
            setcheckall(false);
        }
    };

    const handleSelectAllQuestions = (event) => {
        let newArray = JSON.parse(JSON.stringify(examSetArray));
        newArray.map((item) => {
            return item.questions.map((ques) => {
                Object.assign(ques, { isSelected: event.target.checked });
                return item;
            });
        });
        newArray.forEach((item) => {
            item.sections.isSectionChecked = event.target.checked;
        });
        setExamSetArray(newArray);
        let totalQues = 0;
        newArray.map((item) => {
            return (totalQues = totalQues + item?.questions?.length);
        });

        const arr = [];
        newArray?.map((item) =>
            item?.questions?.filter((data) => {
                if (getQuestionsId(data)) arr.push(getQuestionsId(data));
            })
        );

        if (totalQues === arr?.length) {
            setcheckall(true);
        } else {
            setcheckall(false);
        }
    };

    const validations = () => {
        const arr = examSetArray?.map((item) => item._id);
        return arr.length === 0 ? true : false;
    };

    const renderCopyFrom = () => {
        return (
            <div className="px-3 col-6">
                <div className="fw-bold text-primary pb-2">Copy From</div>

                <div className="d-flex mb-2 align-items-center">
                    <LabelField labelName={"Exam Name"} />
                    <CustomDropdown
                        labelName={"select Exam Name"}
                        setInputText={(value) => onListChange(value)}
                        value={examName}
                        options={examList}
                        Isrequired={true}
                        reset={resetState.exam}
                    />
                </div>
                {subExamList.length > 0 ? (
                    <div className="d-flex mb-2 align-items-center">
                        <LabelField labelName={" Sub Exam Name"} />
                        <CustomDropdown
                            labelName={"select Sub Exam name"}
                            setInputText={(value) => onSubExamChange(value)}
                            value={subExamName}
                            options={subExamList}
                            Isrequired={true}
                            reset={resetState.subExam}
                        />
                    </div>
                ) : null}
                <div className="d-flex mb-2 align-items-center">
                    <LabelField labelName={"Exam Stream"} />
                    <CustomDropdown
                        labelName={"Select Exam Stream"}
                        setInputText={(value) => onChangeParentCourse(value)}
                        value={parentCourse}
                        options={parentCourseList}
                        Isrequired={true}
                        reset={resetState.parentCourse}
                    />
                </div>
                <div className="d-flex mb-2 align-items-center">
                    <LabelField labelName={"Exam Type"} />
                    <CustomDropdown
                        setInputText={(value) => onExamTypeChange(value)}
                        value={examType}
                        options={examTypeList}
                        labelName={"select Exam Type"}
                        Isrequired={true}
                        reset={resetState.examType}
                    />
                </div>
                {examType?._id === 1 ||
                    examType?._id === 2 ||
                    examType?._id === 4 ||
                    examType?._id === 3 ? (
                    <div className="d-flex mb-2 align-items-center">
                        <ToggleSwitchBtn
                            isActive={isFreeUser}
                            labelName={"Free User"}
                            getToggleval={toggleChange}
                        />
                    </div>
                ) : null}
                {examType?._id === 1 || examType?._id === 3 ? (
                    <div className="d-flex mb-2 align-items-center">
                        <ToggleSwitchBtn
                            isActive={isPYQ}
                            labelName={"PYQ"}
                            getToggleval={(e) => {
                                setIsPYQ(e.target.checked);
                                setIsPracticeTest(false);
                            }}
                        />
                    </div>
                ) : null}
                {examType?._id === 1 || examType?._id === 2 || examType?._id === 3 ? (
                    <div className="d-flex mb-2 align-items-center">
                        <ToggleSwitchBtn
                            isActive={isPracticeTest}
                            labelName={"Practice Test"}
                            getToggleval={(e) => {
                                setIsPracticeTest(e.target.checked);
                                setIsPYQ(false);
                            }}
                        />
                    </div>
                ) : null}
                {(examType?._id === 1 ||
                    examType?._id === 2 ||
                    examType?._id === 4 ||
                    examType?._id === 6) &&
                    !isFreeUser ? (
                    <div className="d-flex mb-2 align-items-center">
                        <LabelField labelName={"Batch Name"} />
                            <Dropdown
                            search={true}
                            setInputText={(value) => onBatchChange(value)}
                            value={batchName}
                            options={batchList}
                            labelName={"Select Exam Batch Name"}
                            Isrequired={
                                examType._id === 1 ||
                                    examType._id === 2 ||
                                    examType?._id === 4 ||
                                    examType?._id === 6
                                    ? true
                                    : false
                            }
                            reset={resetState.batch}
                        />
                    </div>
                ) : null}
                {examType?._id === 5 ? (
                    <div className="d-flex mb-2 align-items-center">
                        <LabelField labelName={"Model Set Paper"} />
                        <CustomDropdown
                            setInputText={(value) => onChangeModelSet(value)}
                            value={modelSet}
                            defaultValue={modelSet._id}
                            options={data}
                            labelName="Select Model Set"
                            Isrequired={true}
                        />
                    </div>
                ) : null}
                <div className="d-flex mb-2 align-items-center">
                    <LabelField labelName={"Pattern Name"} />
                    <CustomDropdown
                        labelName={"Select Pattern Name"}
                        options={patternList}
                        setInputText={(value) => onChangePattern(value)}
                        Isrequired={true}
                        value={patternName}
                        reset={resetState.pattern}
                    />
                </div>
                <div className="d-flex mb-2 align-items-center">
                    <LabelField labelName={"Exam Set Name"} />
                    <CustomDropdownExamname
                        labelName={"Select Exam Set Name"}
                        options={examSetList}
                        setInputText={(value) => onExamSetChange(value)}
                        Isrequired={true}
                        reset={resetState.examSet}
                    />
                </div>
                <div className="d-flex mb-2 align-items-center w-100">
                    <LabelField labelName={"Subject Name"} />
                    <div className="col-md-6">
                    <CustomDropdown
                        labelName={"Select Subject Name"}
                        setInputText={(value) => onSubjectChange(value)}
                        Isrequired={true}
                        value={subject}
                        options={subjectList}
                        reset={resetState.subject}
                        defaultValue={subject?._id}
                    />
                    </div>
                </div>
                <div className="d-flex mb-2 align-items-center">
                    <LabelField labelName={"Topic Name"} />
                    <CustomDropdown
                        labelName={"Select Topic Name"}
                        options={topicList}
                        setInputText={(value) => onTopicChange(value)}
                        Isrequired={true}
                        value={topic}
                        reset={resetState.topic}
                        defaultValue={topic?._id}
                    />
                </div>
                <div className="d-flex mb-2 align-items-center">
                    <LabelField labelName={"Year"} />
                    <CustomDropdown
                        labelName={"Select Year"}
                        options={yearList}
                        setInputText={(value) => onYearChange(value)}
                        Isrequired={true}
                        value={year}
                        reset={resetState.year}
                    />
                </div>
            </div>
        );
    };

    const renderCopyTo = () => {
        return (
            <div className="px-3 col-6">
                <div className="fw-bold text-primary pb-2">Copy To</div>
                <div className="col-md-6">
                    <div className="d-flex mb-2 align-items-center">
                        <LabelField labelName={"Exam Name"} isRequired={true} />
                        <CustomDropdown
                            setInputText={(value) => onListChangeCopy(value)}
                            value={examNameCopy}
                            options={examList}
                            labelName="Select Exam Name"
                            reset={resetExam}
                        // Isrequired={true}
                        />
                    </div>
                    <div className="d-flex mb-2 align-items-center">
                        <LabelField labelName={"Exam Stream"} isRequired={true} />
                        <CustomDropdown
                            setInputText={(value) => onChangeParentCourseCopy(value)}
                            value={parentCourseCopy}
                            options={parentCourseListCopy}
                            labelName="Select Exam Stream"
                            reset={resetParentCourse}
                        // Isrequired={true}
                        />
                    </div>
                    <div className="d-flex mb-2 align-items-center">
                        <LabelField labelName={"Chat ID"} isRequired={true} />
                        <CustomDropdown
                            setInputText={(value) => changeChatId(value)}
                            value={chatID}
                            options={ChatList}
                            labelName="Select Chat ID"
                            reset={resetChatID}
                        // Isrequired={true}
                        />
                    </div>
                    <div className="d-flex align-items-center w-100">
                        <LabelField labelName={"Quiz Start Date & Time"} isRequired={true} />
                        <DateTime
                            setInputText={(value) => {
                                setQuizStartDate(value);
                            }}
                            value={quizStartDate}
                        />
                    </div>

                    <div className="d-flex align-items-center w-100">
                        <InputField
                            labelName={"Quiz Duration (In Minutes)"}
                            placeholder={"Enter Duration"}
                            setInputText={(value) =>
                                setDuration(value)
                            }
                            value={duration}
                            maxLength={length_Three}
                            minLength={length_One}
                            Isrequired={true}
                        />

                    </div>
                    <div className="d-flex align-items-center w-100">
                        <InputField
                            labelName={"Topic Name"}
                            placeholder={"Enter Topic Name"}
                            setInputText={(value) =>
                                setTopicName(value)
                            }
                            value={topicName}
                            // maxLength={length_Fifty}
                            minLength={length_One}
                            Isrequired={true}
                        />

                    </div>
                </div>
            </div>
        );
    };
    const renderTable = () => {
        return (
            <table className="w-100 ">
                <thead className="text-center">
                    <tr>
                        <th style={{ width: "10%" }}>
                            <input
                                type="checkbox"
                                id={selectedSectionId}
                                onClick={handleSelectAllQuestions}
                                checked={checkall}
                            />
                            <label> Copy all</label>
                        </th>
                        <th className="text-start">
                            <label>Question</label>
                        </th>
                        <th>
                            <label>Order</label>
                        </th>
                    </tr>
                </thead>
                <tbody className="text-center">
                    {examSetArray?.map((item, index) => {
                        if (selectedSectionId === item?.sections?._id) {
                            if (item?.questions?.length > 0) {
                                return item?.questions?.map((data, index) => {
                                    return (
                                        <tr key={index}>
                                            <td style={{ width: "5%" }}>
                                                <input
                                                    type="checkbox"
                                                    id={data?._id}
                                                    value={data?.section?.sectionId}
                                                    onChange={checkval}
                                                    checked={data.isSelected}
                                                />
                                            </td>
                                            <td className="text-start">
                                                {renderQuestions(data?.en?.title)}
                                            </td>
                                            <td>
                                                {data?.questionType === 1
                                                    ? "MCQ"
                                                    : data?.questionType === 2
                                                        ? "MSQ"
                                                        : "NAT"}
                                            </td>
                                        </tr>
                                    );
                                });
                            } else {
                                return (
                                    <tr key={index}>
                                        <td colSpan={3}>No questions in selected exam set</td>
                                    </tr>
                                );
                            }
                        }
                    })}
                </tbody>
            </table>
        );
    };

    const getSectionWiseQuestion = (id, item) => {
        setSelectedSectionId(id);
        var newArray = item.filter(function (el) {
            return el?.section?.sectionId === id;
        });
        return newArray;
    };

    const getQuestion = (id) => {
        return setSelectedSectionId(id);
    };

    const getAvailableCount = (parts) => {
        let MCQ = 0;
        let MSQ = 0;
        let NAT = 0;
        let availableCount = 0;
        parts?.map((data) => {
            if (data?.questionType === 1) {
                MCQ =
                    MCQ +
                    (data?.totalQuestions -
                        (data?.addedQuestion ? data?.addedQuestion : 0));
            } else if (data?.questionType === 2) {
                MSQ =
                    MSQ +
                    (data?.totalQuestions -
                        (data?.addedQuestion ? data?.addedQuestion : 0));
            } else if (data?.questionType === 3) {
                NAT =
                    NAT +
                    (data?.totalQuestions -
                        (data?.addedQuestion ? data?.addedQuestion : 0));
            }
            // return (availableCount = `MCQ - ${MCQ}, MSQ - ${MSQ}, NAT - ${NAT}`);
            return (availableCount = `${MCQ > 0 ? `MCQ - ${MCQ}` : ""}  ${MSQ > 0 ? `MSQ - ${MSQ}` : ""
                }  ${NAT > 0 ? `NAT - ${NAT}` : ""}`);
        });
        return availableCount;
    };

    return (
        <div className="contentBox">
            <PageTitle name={"COPY QUESTIONS TO QUIZ"} />
            <div className="row m-0">
                <div className="formDiv ">
                    <form className="col-12 formWidth " onSubmit={handleSubmit}>
                        <div className="col-auto">
                            <div className="row d-flex w-100">
                                {renderCopyFrom()}
                                {renderCopyTo()}
                            </div>
                            <div className="d-flex d-row justify-content-between align-items-center mb-2">
                                <div>
                                    {examSetArray?.map((item, index) => {
                                        return (
                                            <span key={index} style={{ marginRight: "3px" }}>
                                                <button
                                                    key={`button ${index}`}
                                                    type="button"
                                                    className={
                                                        item?.sections?._id === selectedSectionId
                                                            ? "btn border-primary me-2"
                                                            : "btn border me-2"
                                                    }
                                                    id={item?.sections?._id}
                                                    onClick={() => getQuestion(item?.sections?._id)}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        id={selectedSectionId}
                                                        onClick={(event) =>
                                                            handleSectionAllQuestions(event, index)
                                                        }
                                                        checked={item?.sections?.isSectionChecked}
                                                        className="me-1"
                                                    />

                                                    {item?.sections?.name}
                                                </button>
                                            </span>
                                        );
                                    })}
                                </div>
                                <div className="d-column">
                                    {questionsListCopy?.sections?.length > 0 ? (
                                        <h6 className="fw-bold">Available Questions to copy</h6>
                                    ) : null}
                                    <div className="d-flex d-row">
                                        {questionsListCopy?.sections?.map((item, index) => {
                                            return (
                                                <div
                                                    key={`button ${index}`}
                                                    className={
                                                        "d-flex flex-column me-2 align-items-center border p-2"
                                                    }
                                                    id={item._id}
                                                >
                                                    <div>{item.name}</div>
                                                    <div>{getAvailableCount(item.parts)}</div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                            {renderTable()}
                            <div className=" d-flex justify-content-end mt-4">
                                <SubmitButton name="Copy Exam Set" disabled={validations()} />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CopyQuestionToQuiz;